import { IFilter, IFilterChips } from "@/models/filter.model";

export enum FilterViewDialogMode {
  copy = "copy",
  create = "create",
  edit = "edit",
  pending = "pending",
}

export enum FilterViewItemType {
  view = 'View',
  folder = 'Folder',
}

export enum FilterViewItemActionType {
  collapseAll = "collapseAll",
  copy = "copy",
  move = "move",
  openInNewTab = "openInNewTab",
  remove = "remove",
  removeFromFolder = "removeFromFolder",
  rename = "rename",
}

export interface IQuickFilterOptions {
  id?: string;
  name: string;
  folderId?: string;
  data: IFilter;
}

export interface IQuickFilterMoveOptions {
  id: string;
  folderId: string;
}

export interface IQuickFilterResponse {
  id: string;
  name: string;
  folderId?: string;
  data: IFilter;
}

export interface IQuickFilterFolderOptions {
  id?: string;
  name: string;
}

export interface IQuickFilterFolderResponse {
  id: string;
  name: string;
}

export interface IQuickFilterItemsResponse {
  filters: IQuickFilterResponse[];
  folders: IQuickFilterFolderResponse[];
}

export interface IQuickFilterViewModel {
  id: string;
  name: string;
  folderId?: string;
  filter: IFilter;
  chips: IFilterChips[];
  isDefault?: boolean;
}

export interface IQuickFilterFolderViewModel {
  id: string;
  name: string;
}

export interface IQuickFilterItemsViewModel {
  filters: IQuickFilterViewModel[];
  folders: IQuickFilterFolderViewModel[];
}

export interface IFilterViewItemActionConfig {
  item: IQuickFilterViewModel | IQuickFilterFolderViewModel | undefined;
  itemType: FilterViewItemType;
  dialogMode?: FilterViewDialogMode;
  confirmationMessage?: string;
}

export interface IFilterViewMenuItemEvent {
  data: IQuickFilterViewModel | IQuickFilterFolderViewModel;
  actionItemType: FilterViewItemType;
  actionType: FilterViewItemActionType;
}